"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

var BottleneckError, States;
BottleneckError = require("./BottleneckError");

States = /*#__PURE__*/function () {
  function States(status1) {
    _classCallCheck(this, States);

    this.status = status1;
    this._jobs = {};
    this.counts = this.status.map(function () {
      return 0;
    });
  }

  _createClass(States, [{
    key: "next",
    value: function next(id) {
      var current, next;
      current = this._jobs[id];
      next = current + 1;

      if (current != null && next < this.status.length) {
        this.counts[current]--;
        this.counts[next]++;
        return this._jobs[id]++;
      } else if (current != null) {
        this.counts[current]--;
        return delete this._jobs[id];
      }
    }
  }, {
    key: "start",
    value: function start(id) {
      var initial;
      initial = 0;
      this._jobs[id] = initial;
      return this.counts[initial]++;
    }
  }, {
    key: "remove",
    value: function remove(id) {
      var current;
      current = this._jobs[id];

      if (current != null) {
        this.counts[current]--;
        delete this._jobs[id];
      }

      return current != null;
    }
  }, {
    key: "jobStatus",
    value: function jobStatus(id) {
      var ref;
      return (ref = this.status[this._jobs[id]]) != null ? ref : null;
    }
  }, {
    key: "statusJobs",
    value: function statusJobs(status) {
      var k, pos, ref, results, v;

      if (status != null) {
        pos = this.status.indexOf(status);

        if (pos < 0) {
          throw new BottleneckError("status must be one of ".concat(this.status.join(', ')));
        }

        ref = this._jobs;
        results = [];

        for (k in ref) {
          v = ref[k];

          if (v === pos) {
            results.push(k);
          }
        }

        return results;
      } else {
        return Object.keys(this._jobs);
      }
    }
  }, {
    key: "statusCounts",
    value: function statusCounts() {
      var _this = this;

      return this.counts.reduce(function (acc, v, i) {
        acc[_this.status[i]] = v;
        return acc;
      }, {});
    }
  }]);

  return States;
}();

module.exports = States;